import { CANCEL_TASK, CANCEL_TASK_SUCCESSFUL, CANCEL_TASK_FAILED } from './actionTypes';

const initialState = {
    cancelTaskError: null, messageDeleteTask: null, loadingDeleteTask: false
}

const cancelTask = (state = initialState, action) => {
    switch (action.type) {
        case CANCEL_TASK:
            state = {
                ...state,
                loadingDeleteTask: true,
                cancelTaskError: null
            }
            break;
        case CANCEL_TASK_SUCCESSFUL:
            state = {
                ...state,
                loadingDeleteTask: false,
                messageDeleteTask: action.payload,
                cancelTaskError: null
            }
            break;
        case CANCEL_TASK_FAILED:
            state = {
                ...state,
                messageDeleteTask: null,
                loadingDeleteTask: false,
                cancelTaskError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default cancelTask;